import { forwardRef, memo, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { Box, ButtonBase, Menu, MenuItem } from '@material-ui/core';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { classNames } from '../../../../utils';
import { AddIcon, DeleteIcon, EyeHideIcon, MoreIcon, ReNameIcon, ShowIcon } from '../../../../components/Icon';
import { i18n } from '../../../../language';
import Card from './card';
import { functionFunc, groupDataFunc } from './constant';
import { Delete, Rename } from './list';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    border: '0.0625rem solid #e4e7eb',
    padding: '2.5rem 0 1.5rem 1.563rem',
    marginBottom: '1.875rem',
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    letterSpacing: '-0.05375rem',
    color: theme.palette.font.main,
    fontWeight: 'bold',
    marginBottom: '2.5rem',
    display: 'flex',
    justifyContent: 'space-between',
  },
  body: {
    display: 'flex',
    flexWrap: 'wrap',
    maxHeight: '30rem',
    overflowY: 'auto',
    '&>div': {
      marginRight: '1.688rem',
      marginBottom: '1.688rem',
    },
    '&>div:last-child': {
      marginRight: '0',
    },
  },
  iconBox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.563rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  menu: {
    boxShadow: '0 0 1rem 0 rgba(125, 134, 169, 0.2)',
    borderRadius: '0.16875rem',
    margin: '4rem 0 0 0rem',
    '& .MuiList-root': {
      '&>li:first-child': {
        border: '0',
      },
    },
    '& .MuiPopover-paper': {
      overflow: 'visible',
      '&::before': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        content: '""',
        display: 'block',
        borderBottom: '0.688rem solid #fff',
        borderLeft: '0.688rem solid transparent',
        borderRight: '0.688rem solid transparent',
        width: '1.376rem',
        height: '0.688rem',
        zIndex: '10',
      },
      '&::after': {
        position: 'absolute',
        top: '-0.688rem',
        left: '50%',
        content: '""',
        display: 'block',
        borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
        borderLeft: '0.8rem solid transparent',
        borderRight: '0.8rem solid transparent',
        width: '1.6rem',
        height: '0.8rem',
        zIndex: '0',
      },
    },
  },
  menuitem: {
    padding: '1.25rem 1rem',
    height: '3.75rem',
    width: '13.313rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    borderTop: '0.0625rem solid #e4e7eb',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  renameIcon: {
    fontSize: '0.938rem',
    color: '#525e6c',
  },
  iconbox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.063rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addBtn: {
    width: '5.813rem',
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.palette.primary.main,
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
    marginRight: '1.563rem',
  },
  addIcon: {
    fontSize: '1rem',
    color: theme.palette.font.white,
    marginRight: '0.313rem',
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: '#525e6c',
  },
}));

const CardItem = SortableElement(({ card, allData, triggerFunction, updateGroup, focusCheck, errorMsg, cardIndex, smartComm  }) => (
  <Card
    title={functionFunc.getFunctionName(card)}
    // accept={groupDataFunc.getGroupName(allData) + groupDataFunc.getGroupOrder(allData)}
    accept={`${groupDataFunc.getGroupId(allData)}`}
    // triggerFunction={(preIndex, nextIndex) => {
    //   return updateGroup(groupDataFunc.triggerFunction(allData, preIndex, nextIndex));
    // }}
    triggerFunction={triggerFunction}
    key={functionFunc.getId(card)}
    id={functionFunc.getId(card)}
    reName={(title) => {
      return updateGroup(groupDataFunc.reNameDutyIC(allData, cardIndex, title));
    }}
    delectListDate={() => {
      updateGroup(groupDataFunc.delectFunction(allData, cardIndex));
    }}
    focusCheck={focusCheck}
    errorMsg={errorMsg}
    smartComm={smartComm}
  />
));

const CardList = SortableContainer(({ triggerFunction, classes, allData, updateGroup, focusCheck, errorMsg, smartComm }) => (
  <div className={classNames(classes.body, 'dndBody')}>
    {_.map(groupDataFunc.getAllFunction(allData), (card, index) => {
      return (
        <CardItem
          card={card}
          allData={allData}
          triggerFunction={triggerFunction}
          updateGroup={updateGroup}
          focusCheck={focusCheck}
          errorMsg={errorMsg}
          cardIndex={index}
          key={functionFunc.getId(card)}
          index={index}
          value={functionFunc.getId(card)}
          smartComm={smartComm}
        />
      );
    })}
  </div>
));

const DutyIc = memo(
  forwardRef(function DutyIC({ allData, updateGroup, focusCheck, errorMsg, triggerFunction, delectGroup, smartComm }, ref) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(false);
    const [show, setShow] = useState(Boolean(groupDataFunc.getHide(allData)));
    const [renameDialogOpen, setRenameDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const handleRename = (groupName) => {
      updateGroup(groupDataFunc.setGroupName(allData, groupName));
    };

    const undpateHideNameHandle = (isHide) => {
      updateGroup(groupDataFunc.setHide(allData, Number(isHide)));
    };

    const delectGroupHandle = () => {
      setDeleteDialogOpen(true);
    };

    const addGroupHandle = () => {
      updateGroup(groupDataFunc.addFunction(allData));
    };

    const handleSortEnd = useCallback(
      (result) => {
        triggerFunction(result.oldIndex, result.newIndex);
      },
      [triggerFunction]
    );

    return (
      <div className={classes.root} ref={ref}>
        {deleteDialogOpen ? (
          <Delete
            open={deleteDialogOpen}
            id="DutyAssign-Delete-agb"
            headerTitle={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE')}
            setopen={setDeleteDialogOpen}
            handleDelete={delectGroup}
            content={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE_BODY')}
          />
        ) : (
          ''
        )}
        {renameDialogOpen && (
          <Rename
            headerTitle={i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_RENAME')}
            open={renameDialogOpen}
            id="DutyAssign-Rename-agc"
            setopen={setRenameDialogOpen}
            handleRename={handleRename}
            title={groupDataFunc.getGroupName(allData)}
          />
        )}
        <div className={classes.title}>
          {groupDataFunc.getHide(allData) === 0 ? (
            <div className={classes.title}> {groupDataFunc.getGroupName(allData)}</div>
          ) : (
            <div />
          )}
          <Box display="flex" alignItems="center">
            <ButtonBase className={classes.addBtn} onClick={addGroupHandle} id="DutyAssign-ButtonBase-agd">
              <AddIcon className={classes.addIcon} />
              {i18n.t('DUTYASSIGN_ROSTER_ADD')}
            </ButtonBase>
            <ButtonBase
              className={classes.iconBox}
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
              }}
              id="DutyAssign-ButtonBase-age"
            >
              <MoreIcon className={classes.icon} />
            </ButtonBase>
          </Box>
        </div>
        <Menu
          className={classes.menu}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          id="DutyAssign-Menu-agf"
          onClose={() => {
            setAnchorEl(false);
          }}
          keepMounted
        >
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              setRenameDialogOpen(true);
              setAnchorEl(false);
            }}
            id="DutyAssign-MenuItem-agg"
          >
            <div className={classes.iconbox}>
              <ReNameIcon className={classes.renameIcon} />
            </div>
            {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_RENAME')}
          </MenuItem>
          {!show ? (
            <MenuItem
              className={classes.menuitem}
              onClick={() => {
                setAnchorEl(false);
                undpateHideNameHandle(true);
                setShow(!show);
              }}
              id="DutyAssign-MenuItem-agh"
            >
              <div className={classes.iconbox}>
                <EyeHideIcon className={classes.deleteIcon} />
              </div>
              {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_HIDE')}
            </MenuItem>
          ) : (
            <MenuItem
              className={classes.menuitem}
              onClick={() => {
                setAnchorEl(false);
                undpateHideNameHandle(false);
                setShow(!show);
              }}
              id="DutyAssign-MenuItem-agi"
            >
              <div className={classes.iconbox}>
                <ShowIcon className={classes.deleteIcon} />
              </div>
              {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DISPLAY')}
            </MenuItem>
          )}
          <MenuItem
            className={classes.menuitem}
            onClick={() => {
              delectGroupHandle();
              setAnchorEl(false);
            }}
            id="DutyAssign-MenuItem-agj"
          >
            <div className={classes.iconbox}>
              <DeleteIcon className={classes.deleteIcon} />
            </div>
            {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_SECTION_DELETE')}
          </MenuItem>
        </Menu>
        <CardList
          triggerFunction={triggerFunction}
          classes={classes}
          allData={allData}
          updateGroup={updateGroup}
          focusCheck={focusCheck}
          errorMsg={errorMsg}
          onSortEnd={handleSortEnd}
          axis="xy"
          enableSmartComm={smartComm}
        />
      </div>
    );
  })
);

export default DutyIc;
